import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosRequestHeaders,
  AxiosResponse,
  AxiosError
} from 'axios'

import qs from 'qs'

import { config } from './config'

import { useAppStore } from '@/store/modules/app'

import { useCache } from '@/hooks/web/useCache'
import api from '@/api'
const { wsCache } = useCache()

const { result_code, base_url } = config

export const PATH_URL = base_url[import.meta.env.VITE_API_BASEPATH]

const dateTransformer = (data) => {
  if (data instanceof Date) {
    // do your specific formatting here
    return data.toLocaleString()
  }
  if (Array.isArray(data)) {
    return data.map((val) => dateTransformer(val))
  }
  if (typeof data === 'object' && data !== null) {
    return Object.fromEntries(Object.entries(data).map(([key, val]) => [key, dateTransformer(val)]))
  }
  return data
}
// 创建axios实例
const service: AxiosInstance = axios.create({
  baseURL: PATH_URL, // api 的 base_url
  timeout: config.request_timeout, // 请求超时时间
  transformRequest: [dateTransformer].concat(axios.defaults.transformRequest)
})

// request拦截器

service.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    if (
      config.method === 'post' &&
      (config.headers as AxiosRequestHeaders)['Content-Type'] ===
      'application/x-www-form-urlencoded'
    ) {
      config.data = qs.stringify(config.data)
    }
    const appStore = useAppStore()
    // const userInfo = await wsCache.get(appStore.getUserInfo)
    const userInfo = appStore?.getUserInfo?.token

    if (userInfo) {
      ; (config.headers as AxiosRequestHeaders)[
        'Authorization'
      ] = `${userInfo.type} ${userInfo.token}`
    }
    // get参数编码
    if (config.method === 'get' && config.params) {
      let url = config.url as string
      url += '?'
      const keys = Object.keys(config.params)
      for (const key of keys) {
        if (config.params[key] !== void 0 && config.params[key] !== null) {
          url += `${key}=${encodeURIComponent(config.params[key])}&`
        }
      }
      url = url.substring(0, url.length - 1)
      config.params = {}
      config.url = url
    }
    return config
  },
  (error: AxiosError) => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    if (response.config.responseType === 'blob') {
      // 如果是文件流，直接过
      return response
    } else {
      return response.data
    }
  },
  async (error: AxiosError) => {
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在2xx范围内
      const { status, data } = error.response
      if (status === 401) {
        const appStore = useAppStore()

        // 未授权，清除用户信息并跳转到登录页
        await appStore.clearStore()
        location.href = '/login'
      } else {
        // 其他错误处理
        console.error(`Error ${status}:`, error)
      }
    }
  }
)

export { service }
